import React from 'react';
import CookieConsent from "react-cookie-consent";
import './CookieBanner.scss';
import {trackEventByUrl} from "../../helpers/events";

const displayCookieBanner = () => {

    // Disable Banner on What's New page.
    if (window.location.pathname === '/whatsnew/app/index.html') return false;

    return true;

};

const CookieBanner = () => displayCookieBanner() ? (
    <CookieConsent location="bottom"
                   buttonText="I accept cookies"
                   cookieName="cookieConsent"
                   containerClasses="cookieBanner__container"
                   buttonClasses="cookieBanner__button"
                   contentStyle={{ margin: '0px auto', padding: '10px 25px' }}
                   style={{ zIndex: '10000', background: "#000", color: '#fff', display: 'flex', flexDirection: 'row', alignItems: 'stretch' }}
                   buttonStyle={{ display: 'flex', margin: 0, background: 'rgb(20, 167, 208)', color: '#fff', fontSize: '14px', fontWeight: 600, padding: '7px 25px' }}
    >
        <span>
            This site uses cookies to offer you a better browsing experience.
            Read how we use cookies and view our privacy policy. <a onClick={() => trackEventByUrl('/about/legaldisclaimers', 'Learn More')} style={{color: '#fff', opacity: '0.8', fontWeight: 600}} href="/about/legaldisclaimers">Learn More</a>
        </span>
    </CookieConsent>
) : null;

export default CookieBanner;



// WEBPACK FOOTER //
// ./frontend/components/CookieBanner/CookieBanner.jsx